/** Hidden retained documents never own shell navigation/audio/usage controls. */
export function activeAppFrame(root: HTMLElement | null): HTMLIFrameElement | null {
  return [...(root?.querySelectorAll<HTMLIFrameElement>("iframe") ?? [])]
    .find(frame => !frame.closest("[hidden]")) ?? null;
}
